import { Box, Button, Collapse, Flex, Text, useDisclosure, VStack } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { BrandBlock } from './BrandBlock';
import { Copyright } from './Copyright';
import { FooterLinkItem } from './FooterLinkItem';
import { LINK_GROUPS, type FooterLinkGroup } from './footerLinks';
import { BORDER, HEADING } from './footerStyles';

const AccordionGroup = ({ group }: { group: FooterLinkGroup }) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <Box>
      <Button
        type='button'
        variant='unstyled'
        w='full'
        h='auto'
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <Flex
          w='full'
          align='center'
          justify='space-between'
          gap={4}
          pt='8px'
          pb='16px'
          borderBottomWidth='0.5px'
          borderBottomColor={BORDER}
        >
          <Text fontWeight='semibold' color={HEADING} textAlign='start' flex={1}>
            <FormattedMessage id={group.titleId} defaultMessage={group.defaultTitle} />
          </Text>
          <Text fontSize='xl' lineHeight='none' fontWeight='normal' color={HEADING} aria-hidden>
            {isOpen ? '×' : '+'}
          </Text>
        </Flex>
      </Button>
      <Collapse in={isOpen} animateOpacity>
        <VStack align='stretch' spacing={3} pb={4} pt={1}>
          {group.links.map((link) => (
            <FooterLinkItem key={link.labelId} link={link} />
          ))}
        </VStack>
      </Collapse>
    </Box>
  );
};

export const FooterMobile = () => (
  <Box w='100%' maxW='container.xl' mx='auto'>
    <BrandBlock />
    <Box mt={8}>
      {LINK_GROUPS.map((group) => (
        <AccordionGroup key={group.titleId} group={group} />
      ))}
    </Box>
    <Box mt={8}>
      <Copyright />
    </Box>
  </Box>
);
